export default "/images/8ae7dea92d1334efd00707f752497e1f.avif";